var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2498 18.5009C14.664 18.5008 15 18.8365 15 19.2507C15 19.6649 14.6644 20.0008 14.2502 20.0009L1.25022 20.0047C0.836 20.0048 0.5 19.6691 0.5 19.2549C0.5 18.8407 0.83557 18.5048 1.24978 18.5047L14.2498 18.5009ZM7.6482 0.0127094L7.75 0.00585938C8.1297 0.00585938 8.4435 0.288009 8.4932 0.654089L8.5 0.755859L8.499 14.4409L12.2208 10.7205C12.4871 10.4543 12.9038 10.4301 13.1974 10.648L13.2815 10.7206C13.5477 10.9869 13.5719 11.4036 13.354 11.6972L13.2814 11.7813L8.2837 16.7779C8.0176 17.044 7.6012 17.0683 7.3076 16.8507L7.2235 16.7782L2.22003 11.7816C1.92694 11.4889 1.92661 11.014 2.21931 10.7209C2.48539 10.4545 2.90204 10.43 3.1958 10.6477L3.27997 10.7202L6.999 14.4339L7 0.755859C7 0.376159 7.2822 0.0623694 7.6482 0.0127094Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ac6d69c77c867b4802dcfff1e46bb893.svg";
export { ForwardRef as ReactComponent };